<template>
  <el-tooltip
    class="box-item"
    effect="dark"
    :content="tooltipText"
    placement="top"
  >
    <!-- 如果有匹配的图片图标，显示图片 -->
    <img
      v-if="iconSrc"
      :src="iconSrc"
      :alt="tooltipText"
      :class="['icon-img', { disabled: disabled }]"
      @click="handleClick"
    />
    <!-- 否则显示 iconfont 图标 -->
    <div
      v-else
      :class="['iconfont', iconClass, { disabled: disabled }]"
      @click="handleClick"
    ></div>
  </el-tooltip>
</template>

<script setup lang="ts">
import { computed } from "vue";
// 定义组件属性
interface Props {
  iconName?: string; // iconfont 图标名称，如 'icon-bianji'（可选）
  tooltipText: string; // 提示文本，如 '编辑'
  disabled?: boolean; // 是否禁用
}

const props = withDefaults(defineProps<Props>(), {
  iconName: "",
  disabled: false,
});

// 定义事件
const emit = defineEmits<{
  click: [];
}>();

// 标签名称与图片文件名的映射表
const tagIconMap: Record<string, string> = {
  发布: "fabu.png",
  刷新: "shuaxin.png",
  推广: "tuiguang.png",
  值映射: "yingshe.png",
  映射: "yingshe.png",
  导出: "daochu.png",
  结算单: "jiesuandan.png",
  订单: "dingdan.png",
  媒体: "meiti.png",
  广告: "guanggao.png",
  编辑: "bianji.png",
};

// 根据 tooltipText 动态获取图片路径
const iconSrc = computed(() => {
  // 遍历映射表，检查 tooltipText 是否包含关键词
  for (const [keyword, filename] of Object.entries(tagIconMap)) {
    if (props.tooltipText.includes(keyword)) {
      return new URL(`../../assets/ctrlicon/${filename}`, import.meta.url).href;
    }
  }
  return ""; // 如果没有匹配的图标，返回空字符串（使用 iconfont）
});

// 计算图标类名
const iconClass = computed(() => {
  return props.iconName;
});

// 处理点击事件
const handleClick = () => {
  if (!props.disabled) {
    emit("click");
  }
};
</script>

<style scoped>
.iconfont {
  cursor: pointer;
  font-size: 18px;
  color: #678adc;
  transition: all 0.3s ease;
  display: inline-block;
  padding: 4px;
}

.iconfont:hover {
  color: #5a7bc8;
  transform: scale(1.1);
}

.iconfont:active {
  transform: scale(0.95);
}

/* 禁用状态 */
.iconfont.disabled {
  cursor: not-allowed;
  color: #c0c4cc;
  opacity: 0.6;
}

.iconfont.disabled:hover {
  color: #c0c4cc;
  transform: none;
}

/* 图片图标样式 */
.icon-img {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-block;
  object-fit: contain;
}

.icon-img:hover {
  transform: scale(1.1);
  filter: brightness(1.1);
}

.icon-img:active {
  transform: scale(0.95);
}

/* 图片禁用状态 */
.icon-img.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  filter: grayscale(100%);
}

.icon-img.disabled:hover {
  transform: none;
  filter: grayscale(100%);
}
</style>
